<template>
  <div>
    <el-row
      v-for="item in fontListConstant"
      :key="item.value"
      :gutter="15"
      style="line-height:2.5"
    >
      <!-- <el-col :span="8">{{item.label}}</el-col> -->
      <el-col :span="8">
        <img
          style="vertical-align:middle"
          v-bind:src="
            'https://ciyun.5118.com/fonts/preview/' + item.label + '.png'
          "
        />
      </el-col>
      <el-col :span="14" style="text-align: right">
        <el-button
          size="mini"
          :type="activeFont === item.label ? 'primary' : ''"
          @click="changeFont(item.label, item.value, item.fontFamily)"
          >使用</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "SelectFont",
  data() {
    return {
      fontListConstant: [
        // { label: "微软雅黑", value: "微软雅黑" },
        { label: "黑体", value: "SimHei.otf" },
        { label: "楷体", value: "KaiTi.otf" },
        { label: "仿宋", value: "FangSong.otf" },

        { label: "隶书", value: "Bauhaus ITC.otf" },
        { label: "站酷酷黑体", value: "HuXiaoBoKuHei.otf" },
        { label: "站酷快乐体", value: "HappyZcool.otf" },
        { label: "站酷黄油体", value: "zhengqingkehuangyoutiRegular 常规.otf" },
        { label: "站酷高端黑", value: "zcool-gdh.otf" },
        { label: "庞门正道粗书体", value: "PangMenZhengDao-Cu.otf" },
        { label: "庞门正道标题体", value: "PangMenZhengDao.otf" },
        { label: "沐瑶软笔书写体", value: "Muyao-Softbrush.otf" },
        { label: "锐字真言体", value: "ZhenyanGB.otf" },
        { label: "思源黑体-常规", value: "Noto Sans S Chinese Regular.otf" },
        { label: "方正楷体简体", value: "FZKai-Z03S.otf" },
        { label: "方正书宋简体", value: "FZShuSong-Z01S.otf" },
        { label: "方正仿宋简体", value: "FZFangSong-Z02S.otf" }
      ],
      activeFont: "黑体",
      fontUrl: "https://ciyun.5118.com/fonts/SimHei.otf",
      fontFamily: "黑体"
    };
  },
  methods: {
    changeFont(fontName, _fontUrl, _fontFamily) {
      this.activeFont = fontName;
      this.fontFamily = _fontFamily;
      this.fontUrl = "https://ciyun.5118.com/fonts/" + _fontUrl;
      // this.fontUrl = _fontUrl
      this.$emit("changeFont");
    }
  }
};
</script>

<style scoped></style>
